import { render, staticRenderFns } from "./OrderPromoList.vue?vue&type=template&id=ade1b270&"
import script from "./OrderPromoList.vue?vue&type=script&lang=js&"
export * from "./OrderPromoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports